import React from 'react';

const NewsCard = ({ title, date, excerpt, image, category }) => {
  return (
    <div className="news-card">
      <img src={image} alt={title} />
      <div className="news-content">
        <h3>{title}</h3>
        <p>{excerpt}</p>
        <span>{date} | {category}</span>
      </div>
    </div>
  );
};

export default NewsCard;
